<script lang="ts">
  import Icon from '../components/icons/Icon.svelte';
  import * as Icons from 'lucide-svelte';
</script>

<nav class="LayoutQuick">
  <button class="quickItem quickSearch">
    <Icon icon={Icons.Search} size={1.5} />
  </button>
  <button class="quickItem">
    <Icon icon={Icons.Star} size={1.5} />
  </button>
  <button class="quickItem alert">
    <Icon icon={Icons.Bell} size={1.5} />
  </button>
  <button class="quickItem counts" data-count="3">
    <Icon icon={Icons.Mail} size={1.5} />
  </button>
</nav>

<style lang="scss">
  @use '../../styles/mixins';

  .LayoutQuick {
    display: flex;
    gap: 0.5rem;

    .quickSearch {
      display: block;
      @include mixins.greaterNav() {
        display: none;
      }
    }

    .quickItem {
      position: relative;
      cursor: pointer;

      &.alert {
        &::after {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          width: 10px;
          height: 10px;
          background-color: var(--color-error);
          border-radius: 50%;
        }
      }

      &.counts {
        &::after {
          content: attr(data-count);
          position: absolute;
          top: -2px;
          right: -3px;
          font-size: 0.5rem;
          color: #fff;
          border-radius: 50%;
          padding: 0.125rem 0.25rem;
          background-color: var(--color-notice);
        }
      }
    }
  }
</style>
